<script setup lang="ts">
import { ref, onMounted } from 'vue';
import CookieConsent from '@/components/CookieConsent/CookieConsent.vue';
import DashboardNavbar from '@/components/Navbar/DashboardNavbar.vue';
import LoadingSpinner from '@/components/Loading/LoadingSpinner.vue';

const isLoading = ref(true);

onMounted(() => {
  // Simulate loading time for images and content
  setTimeout(() => {
    isLoading.value = false;
  }, 1500); // Adjust this time based on your needs
});
</script>

<template>
  <div class="layout">
    <DashboardNavbar />
    <div class="layout__content">
      <router-view />
    </div>
    <CookieConsent />
    <LoadingSpinner
      v-if="isLoading"
      :background="'rgba(255, 255, 255, 0.95)'"
      :spinner-color="'$brown-200'"
      :text-color="'$brown-400'"
      :fullscreen="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, $brown-600 0%, $white-100 100%);

  &__content {
    flex: 1;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 1280px;
    overflow: hidden;
    background-color: inherit;
    padding-top: 6rem; // Dodajemy padding-top aby kompensować wysokość navbara
  }
}
</style>
